export default __webpack_public_path__ + "locales/sl/SmartBanner.json?hash=d22e8219a7f39fd08f3877a0825b6928";